<template>
	<view class="box">
		<view class="yue">
			<view class="yue-a">提现</view>
			<view class="yue-b">-¥1000.00</view>
			<view class="yue-c succ">审核中</view>
		</view>
		<view class="info">
			<view class="info-item">
				<view class="info-item-label">提交时间</view>
				<view class="info-item-val">2025-12-31 21:00:22</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">提现银行</view>
				<view class="info-item-val">中国工商银行大钟楼支行(8788)</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">审核时间</view>
				<view class="info-item-val">2025-12-31 21:00:22</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">打款银行</view>
				<view class="info-item-val">中国工商银行大钟楼支行</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">备注信息</view>
				<view class="info-item-val">-</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">打款凭证</view>
				<view class="info-item-list">
					<view class="info-item-list-item">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
					<view class="info-item-list-item">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
					<view style="width: 120rpx; height: 0rpx;"></view>
					<view style="width: 120rpx; height: 0rpx;"></view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.yue {
			width: 100%;
			height: 286rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			background: #FFFFFF;
			.yue-a {
				font-weight: 400;
				font-size: 30rpx;
				color: #222222;
			}
			.yue-b {
				font-weight: 600;
				font-size: 48rpx;
				color: #222222;
				margin-top: 30rpx;
			}
			.succ {
				background: rgba(0,64,150,0.1) !important;
				color: #004096 !important;
			}
			.err {
				background: rgba(228,0,29,0.1);
				color: #E4001D;
			}
			.yue-c {
				width: 110rpx;
				height: 48rpx;
				line-height: 48rpx;
				text-align: center;
				border-radius: 8rpx;
				font-weight: 400;
				font-size: 26rpx;
				margin-top: 20rpx;
			}
		}
		.info {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 20rpx;
			display: flex;
			flex-direction: column;
			.info-item {
				width: 100%;
				display: flex;
				align-items: flex-start;
				margin-bottom: 30rpx;
				&:last-child {
					margin: 0 !important;
				}
				.info-item-label {
					flex-shrink: 0;
					font-weight: 400;
					font-size: 28rpx;
					color: #666666;
					margin-right: 40rpx;
				}
				.info-item-val {
					flex: 1;
					font-weight: 400;
					font-size: 28rpx;
					color: #222222;
				}
				.info-item-list {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
					flex-wrap: wrap;
					.info-item-list-item {
						width: 120rpx;
						height: 120rpx;
						border-radius: 8rpx;
						image {
							width: 100%;
						}
					}
				}
			}
		}
	}
</style>